
export default theme => ({
	wrapper: {
		overflow: "hidden"
	},

	main: {
		width: "100vw",
		height: "100vh",
		overflow: "hidden",
		position: "relative"
	},
	mainTitle: {
		backgroundColor: "rgba(0,0,0,0.5)",
		color: "#fff",
		position: "absolute",
		top: theme.spacing.unit * 5,
		left: theme.spacing.unit * 5,
		padding: `${theme.spacing.unit}px ${theme.spacing.unit * 3}px`,
		textTransform: "uppercase"
	},
	poi: {
		width: "100px",
		height: "100px",
		borderRadius: "100%",
		backgroundColor: theme.palette.common.white,
		display: "flex",
		alignItems: "center",
		position: "absolute",
		"&.poi1": {
			left: "32%",
			top: "66%"
		},
		"&.poi2": {
			left: "57%",
			top: "32%"
		},
		"&:hover $icon": {
			fill: theme.palette.primary.dark
		}
	},
	icon: {
		width: 35,
		height: 35,
		margin: "auto"
	},
	primaryColor: {
		color: theme.palette.primary.main,
		fill: theme.palette.primary.main
	},
	btnBack: {
		backgroundColor: theme.palette.common.white,
		position: "absolute",
		top: 70,
		left: 20,
		zIndex: 1,
		fontSize: "0.9rem",
		padding: `${theme.spacing.unit / 4}px ${theme.spacing.unit + 4}px`,
		minHeight: "auto",
		height: "auto"
	},
	btnBackLabel: {
		color: theme.palette.primary.main,
		fill: theme.palette.primary.main,
		"& svg": {
			color: theme.palette.primary.main,
			fill: theme.palette.primary.main
		},
		fontSize: "0.7rem"
	},
	arrowBackIcon: {
		marginRight: theme.spacing.unit / 2,
		width: "1.1rem",
		height: "1.1rem"
	},
	googleMapIcon: {
		marginRight: theme.spacing.unit / 2,
		width: "2rem",
		height: "2rem"
	},
	sliderCanvas:{
		backgroundColor: theme.palette.primary.background,
		color: theme.palette.primary.background,
		position: "absolute",
		top: "25%",
		right: "8rem",
		zIndex: 1,
		fontSize: "0.9rem",
		minHeight: "auto",
		background: "rgba(0,0,0,0.7)",
		width: "6.25rem",
		height: "27.688rem"
	},
	contractuel:{
		position:"absolute",
		background:"rgba(255,255,255,1)",
		color: "black",
		top:"2rem",
		left:"10rem",
		textTransform: "uppercase",
		fontFamily: "Inter",
		fontStyle: "normal",
		fontWeight: 500,
		fontSize: "20px",
		textAlign: "center",
		padding: "10px"
	},

	// btnLight: {
	// 	position: "absolute",
	// 	top: 70,
	// 	right: 20,
	// 	width: 30,
	// 	height: 30,
	// 	minHeight: 30,
	// 	minWidth: "auto",
	// 	padding: 0
	// },
	// lightIcon: {
	// 	width: "1.5em",
	// 	height: "1.5em",
	// 	fill: theme.palette.primary.contrastText,
	// 	stroke: theme.palette.primary.contrastText
	// },
	toolbar: theme.mixins.toolbar,
	[theme.breakpoints.down("sm")]: {
		main: {
			width: "100vw",
			height: "100vh"
		},
		welcome: {
			width: "100vw",
			height: "100vh"
		},
		drawer: {
			width: "100vw"
		},
		drawerPaper: {
			width: "100vw"
		},
		icon: {
			cursor: "pointer",
			width: "11%",
			marginLeft: "5px",
			height: "100vh"
		},
		mediaIcons: {
			textAlign: "center"
		},
		mediaSlideShow: {
			top: "55px",
			left: 0,
			right: 0,
			width: "100vw",
			bottom: 0,
			height: "100vh",
			zIndex: 1205,
			position: "fixed",
			background: "rgba(0,0,0,.7)",
			alignItems: "center",
			display: "flex",
			"& .image-gallery": {
				width: "100%",
				marginTop: "24px",
				"& :focus": {
					outline: "none"
				}
			},
			"& h6": {
				top: "5px",
				position: "absolute",
				marginLeft: "auto",
				marginRight: "auto",
				color: "white",
				left: 0,
				right: 0,
				textAlign: "center",
				fontSize: "30px",
				margin: 0,
				textTransform: "capitalize"
			}
		},
		closeSlideShowBtn: {
			position: "absolute",
			top: 0,
			right: "26px",
			color: "#fff"
		}
	},
	interPNG:{
		height:"50px",
		width:"100px",
		padding:"10%"
	}


});
